export * from './lazy-style.handler';
